module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABkAAAAYCAYAAAAPtVbGAAAACXBIWXMAAAsSAAALEgHS3X78AAAAa0lEQVRIiWNM42FIYGBgiGegEZj1hcGRhYGBQUGKhdFBkoWR6rac/fEPTIMsYeBgZGAQZMJQQzVAQ6MRYNSSUUtGLRm1ZNQSHGDUkhFqCbiO//GfgeE9pM6nmSUPnv35f+DZn/+0sYGBgQEA+TQR+nsDcCEAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/blue/shapes/rect-red-1.png
// module id = 247
// module chunks = 0